<template>
    <div>
        <div class="theme-loader">
            <div class="ball-scale">
                <div class='contain'>
                    <img src="../assets/loader.gif">
                </div>
            </div>
        </div>
        <div id="pcoded" class="pcoded">
            <div class="pcoded-overlay-box"></div>
            <div class="pcoded-container navbar-wrapper">

                <navbar1 />

                <div class="pcoded-main-container">
                    <div class="pcoded-wrapper">

                        <navbar2 />

                        <div class="pcoded-content">
                            <div class="pcoded-inner-content">
                                <div class="main-body">
                                    <div class="page-wrapper" style="background: #fff;">
                                        <div class="page-body">
                                            <h5 class="pb-4">Scorecard</h5>

                                            <div class="card" v-if="scorecard_state == 'modify' && $checkPerm('scorecard.edit')">
                                                <div class="card-header">
                                                    <h5>Candidate Interview Scorecard</h5>
                                                    <div class="card-header-right">
                                                        <button class="btn btn-sm btn-primary" data-toggle="modal"
                                                            data-target="#addSection">Add Section</button>
                                                    </div>
                                                </div>
                                                <div class="card-block table-border-style">
                                                    <div class="table-responsive">
                                                        <table class="table table-hover table-default">
                                                            <tbody v-for="(section, index) in scorecard_sections">
                                                                <tr class="section-title">
                                                                    <td>
                                                                        Section {{index + 1}}: {{section.sectionname}}
                                                                        &nbsp;
                                                                        <button data-toggle="modal" v-bind:data-target="'#editSection' + section.id"
                                                                            class="btn btn-primary btn-sm mt-2">Edit
                                                                            Section</button>&nbsp;

                                                                        <button class="btn btn-primary btn-sm mt-2"
                                                                            v-on:click="deleteSection(section.id)">Delete
                                                                            Section</button>
                                                                    </td>
                                                                </tr>
                                                                <tr v-for="(field, index) in scorecard_fields">
                                                                    <td v-if="field.sectionid == section.id">
                                                                        <b>{{field.title}}</b>

                                                                        <p class="mt-4" v-html="field.text"></p>
                                                                        <button data-toggle="modal" v-bind:data-target="'#editField' + field.id"
                                                                            class="btn btn-primary btn-sm mt-2">Edit
                                                                            Field</button>&nbsp;
                                                                        <button class="btn btn-primary btn-sm mt-2"
                                                                            v-on:click="deleteField(field.id)">Delete
                                                                            Field</button>
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <form v-on:submit.prevent="addFieldToSection">
                                                                            <input type="hidden" name="new_field_section"
                                                                                v-bind:value="section.id">
                                                                            <input type="text" name="new_field_title"
                                                                                class="form-control" v-bind:placeholder="'New Field for ' + section.sectionname"
                                                                                autocomplete="off" />
                                                                            <summernote height="300" :model.sync="section.sectiontext"
                                                                                v-bind:value="section.sectiontext">
                                                                            </summernote>

                                                                            <button class="btn btn-primary btn-sm mt-2">Add
                                                                                Field</button>
                                                                        </form>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-if="scorecard_state == 'use' && $checkPerm('application.use_scorecard')">
                                                <div class="card">
                                                    <div class="card-header">
                                                        <h5 v-if="evaluator_card.length < 1">
                                                            Candidate Interview Scorecard
                                                        </h5>
                                                        <h5 v-else>
                                                            Candidate Interview Scorecard <br>
                                                            Evaluator: {{evaluator_card.first_name + " " +
                                                            evaluator_card.last_name}}
                                                        </h5>
                                                    </div>

                                                    <div class="card-block table-border-style">
                                                        <div class="row">
                                                            <div class="col-lg-12 col-xl-12">

                                                                <ul class="nav nav-tabs md-tabs " role="tablist">
                                                                    <li class="nav-item">
                                                                        <a class="nav-link active" data-toggle="tab"
                                                                            href="#scorecard" role="tab">Scorecard</a>
                                                                        <div class="slide"></div>
                                                                    </li>
                                                                    <li class="nav-item" v-if="this.$route.query.evaluator == undefined">
                                                                        <a class="nav-link" data-toggle="tab" href="#new_evaluation"
                                                                            role="tab">New Evaluation</a>
                                                                        <div class="slide"></div>
                                                                    </li>
                                                                </ul>

                                                                <div class="tab-content card-block">

                                                                    <div class="tab-pane active" id="scorecard" role="tabpanel">
                                                                        <div class="table-responsive" v-if="applicant_score.length > 0">
                                                                            <table class="table">
                                                                                <tbody>
                                                                                    <tr>
                                                                                        <td colspan="4">First
                                                                                            Impression</td>
                                                                                        <td colspan="8">{{final_first_impression}}</td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td colspan="4">Interviewer's
                                                                                            Recommendation for
                                                                                            Hire</td>
                                                                                        <td colspan="8">
                                                                                            {{final_hiring_decision}}
                                                                                        </td>

                                                                                    </tr>
                                                                                    <tr v-if="final_hiring_decision== 'Keep in view for another role or opportunity' || final_hiring_decision == 'Other'">
                                                                                        <td colspan="4">Interviewer's
                                                                                            Opinion</td>
                                                                                        <td colspan="8">
                                                                                            {{final_decision_reason}}
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>
                                                                            </table>
                                                                            <table class="table">

                                                                                <thead>
                                                                                    <th colspan=6>Question</th>
                                                                                    <th colspan=2>Score</th>
                                                                                    <th colspan=4>Comment</th>
                                                                                </thead>
                                                                                <tbody>

                                                                                    <tr v-for="score in applicant_score">
                                                                                        <td colspan=6>
                                                                                            <b>{{score.title}}</b>
                                                                                            <p v-html="score.text"></p>
                                                                                        </td>
                                                                                        <td colspan=2>
                                                                                            <p>{{score.score}}</p>
                                                                                        </td>
                                                                                        <td colspan=4>
                                                                                            <p>{{score.comments}}</p>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td colspan=6>
                                                                                            <h5>Total Score</h5>
                                                                                        </td>
                                                                                        <td colspan=6>
                                                                                            <h5>{{applicant_total}}</h5>
                                                                                        </td>
                                                                                    </tr>
                                                                                </tbody>

                                                                            </table>
                                                                        </div>
                                                                        <div v-else>
                                                                            <h5 style="text-align: center;">Applicant
                                                                                has not been scored yet.</h5>
                                                                        </div>
                                                                    </div>
                                                                    <div class="tab-pane" id="new_evaluation" role="tabpanel">
                                                                        <div class="table-responsive">
                                                                            <form role="form" v-on:submit.prevent="submitForm">
                                                                                <table class="table table-hover table-default">
                                                                                    <thead>
                                                                                        <tr class="section-title">
                                                                                            <th colspan=12>MEASURING
                                                                                                INDICIES FOR
                                                                                                COMPETENCIES</th>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <th>Rating Evidence Level:
                                                                                                *
                                                                                                5=Excellent * 4= Good
                                                                                                *3=
                                                                                                Average * 2= Below
                                                                                                Average
                                                                                                * 1= Very Poor *N/A =
                                                                                                Not
                                                                                                Applicable</th>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=4>
                                                                                                <b>First Impression:</b>
                                                                                            </td>
                                                                                            <td colspan=8>
                                                                                                <textarea v-model="answers.first_impression"
                                                                                                    class="form-control"
                                                                                                    required></textarea>
                                                                                                </textarea>
                                                                                            </td>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody v-for="(section, index) in scorecard_sections">

                                                                                        <tr class="section-title">
                                                                                            <td colspan="12">
                                                                                                Section {{index + 1}}:
                                                                                                {{section.sectionname}}
                                                                                            </td>
                                                                                        </tr>
                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <b>Competency Indicator</b>
                                                                                            </td>
                                                                                            <td colspan=2>
                                                                                                <b>Rating </b>
                                                                                            </td>
                                                                                            <td colspan=4>
                                                                                                <b>Interviewer's Notes
                                                                                                    highlighting
                                                                                                    candidates’
                                                                                                    responses to
                                                                                                    various questions
                                                                                                    (Justification for
                                                                                                    Rating)</b>
                                                                                            </td>
                                                                                        </tr>

                                                                                        <tr v-for="(field, index) in scorecard_fields">
                                                                                            <td v-if="field.sectionid == section.id"
                                                                                                colspan=6>
                                                                                                <b v-html="breakString(field.title)"></b>
                                                                                                <p class="mt-4" v-html="breakString(field.text)"></p>
                                                                                            </td>
                                                                                            <td colspan=2 v-show="field.sectionid == section.id && field.title.length > 0">

                                                                                                <input class="form-control"
                                                                                                    type="number"
                                                                                                    v-model="answers.scores[field.id]"
                                                                                                    min="1" max="5"
                                                                                                    required>
                                                                                            </td>
                                                                                            <td colspan=4 v-show="field.sectionid == section.id && field.title.length > 0">
                                                                                                <textarea class="form-control"
                                                                                                    v-model="answers.comments[field.id]"
                                                                                                    required>
                                                                                                    </textarea>
                                                                                            </td>
                                                                                        </tr>

                                                                                        <tr>
                                                                                            <td colspan=6>
                                                                                                <b>Subtotal</b>
                                                                                            </td>
                                                                                            <td colspan=2>
                                                                                                <b>
                                                                                                    {{
                                                                                                    sectionTotal(section.id)
                                                                                                    }}
                                                                                                </b>
                                                                                            </td>
                                                                                            <td colspan=4></td>
                                                                                        </tr>

                                                                                    </tbody>
                                                                                    <tr>
                                                                                        <td colspan=6>
                                                                                            <label>Interviewer's
                                                                                                Recommendation for
                                                                                                Hire</label>
                                                                                        </td>

                                                                                        <td colspan=6>
                                                                                            <select class="form-control"
                                                                                                v-model="answers.hiring_decision"
                                                                                                required>
                                                                                                <option value="Hire">
                                                                                                    Hire
                                                                                                </option>
                                                                                                <option value="Do not hire">
                                                                                                    Do not Hire
                                                                                                </option>
                                                                                                <option value="Keep in view for another role or opportunity">
                                                                                                    Keep in view
                                                                                                    for another
                                                                                                    role or
                                                                                                    opportunity
                                                                                                </option>
                                                                                                <option value="Other">
                                                                                                    Other
                                                                                                </option>
                                                                                            </select>

                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr v-if="answers.hiring_decision == 'Keep in view for another role or opportunity' || answers.hiring_decision == 'Other'">
                                                                                        <td colspan="12">
                                                                                            <textarea v-model="answers.decision_reason"
                                                                                                class="form-control"
                                                                                                placeholder="Reason for your decision."
                                                                                                required></textarea>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td colspan=6>
                                                                                            <b>Total Score</b>
                                                                                        </td>
                                                                                        <td colspan=4>
                                                                                            <b>
                                                                                                {{allSectionTotal()}}/{{overAllTotal}}</b>
                                                                                        </td>
                                                                                    </tr>
                                                                                    <tr>
                                                                                        <td colspan=6>
                                                                                            <b>Percentage</b>
                                                                                        </td>
                                                                                        <td colspan=4>
                                                                                            <b>{{percentSection()}}%
                                                                                            </b>
                                                                                        </td>
                                                                                    </tr>

                                                                                    <button class="btn-primary btn btn-md">Submit</button>
                                                                                </table>
                                                                            </form>

                                                                        </div>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="addSection" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">New Scorecard Section</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="createScoreCardSection">
                            <div class="form-group">
                                <input type="text" name="section_name" class="form-control" required="required"
                                    placeholder="Section Name" v-model="new_section.section" />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success form-control">Create</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(section, index) in scorecard_sections" v-bind:id="'editSection'+ section.id" class="modal fade"
            role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Edit Scorecard Section</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="editScoreCardSection(section.id,index)">
                            <div class="form-group">
                                <input type="text" v-model="scorecard_sections[index].sectionname" name="section_name"
                                    class="form-control" required="required" placeholder="Section Name" />
                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success form-control">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div v-for="(field, index) in scorecard_fields" v-bind:id="'editField'+field.id" class="modal fade" role="dialog">
            <div class="modal-dialog modal-md">
                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Edit Field Section</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>
                    <div class="modal-body project-task">
                        <form role="form" v-on:submit.prevent="editScoreCardField(field.id,index)">
                            <div class="form-group">
                                <input type="hidden" name="new_field_section" v-bind:value="field.sectionid">
                            </div>
                            <div class="form-group">
                                <input type="text" name="new_field_title" class="form-control" v-model="scorecard_fields[index].title"
                                    v-bind:placeholder="'Edit Field for ' + field.sectionname" autocomplete="off" />
                                <summernote height="300" :model.sync="scorecard_fields[index].text"> </summernote>


                            </div>
                            <div class="form-group">
                                <button class="btn btn-md btn-success form-control">Edit</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .section-title {
        text-align: center;
    }

    .section-title td {
        text-transform: uppercase;
        font-weight: bold;
    }

    td {
        white-space: normal !important;
        word-wrap: break-word;
    }

    table {
        table-layout: fixed;
    }
</style>
<script>
    import navbar1 from '../components/Navbar1.vue'
    import navbar2 from '../components/Navbar2.vue'
    import summernote from '../components/Summernote.vue'

    function initalSectionState() {
        return {
            section: ""
        }
    }

    export default {
        name: 'ScoreCard',

        data() {
            return {
                scorecard_sections: [],
                scorecard_fields: [],
                new_section: initalSectionState(),
                new_field: {
                    sectionid: "",
                    sectiontitle: "",
                    sectiontext: ""
                },
                scorecard_state: '',
                subtotal: 0,
                answers: {
                    scores: [],
                    comments: [],
                    first_impression: "",
                    hiring_decision: "",
                    decision_reason: ""
                },

                applicant: {},

                applicant_id: "",

                applicant_score: [],

                evaluator_card: [],

                applicant_total: "",

                all_section_total: "",
                overAllTotal: " ",
                final_first_impression: " ",
                final_hiring_decision: "",
                final_decision_reason: ""
            }
        },

        components: {
            navbar1,
            navbar2,
            summernote
        },

        mounted() {

            this.init()

            if (this.$route.params.id !== undefined) {

                this.scorecard_state = 'use'
                this.applicant_id = this.$route.params.id

                this.getApplicantScoreCard(this.applicant_id)

            } else {
                this.scorecard_state = 'modify'
            }
        },

        methods: {

            init: function () {
                this.getScoreCardSections()
                this.getScoreCardSectionFields()
            },

            sectionTotal: function (section_id) {
                var total = 0
                var subtotal
                this.scorecard_fields.forEach(element => {
                    if (element.sectionid == section_id) {
                        total = total + 5
                        subtotal = +total
                    }
                });

                return total
            },
            allSectionTotal: function () {
                var total = 0
                this.answers.scores.forEach((elem, i) => {
                    var field_index = this.getIndexById(i, this.scorecard_fields)
                    var answer_section_id = this.scorecard_fields[field_index].sectionid
                    total += parseInt(elem)
                });

                this.all_section_total = total
                return total
            },

            percentSection: function () {
                var fields_count = this.scorecard_fields.length * 5
                var section_total = this.all_section_total
                var p_total = (section_total / fields_count) * 100
                this.overAllTotal = this.scorecard_fields.length * 5
                return p_total
            },
            getIndexById: function (id, arr) {
                var index = 0
                arr.forEach((elem, i) => {
                    if (elem.id == id) {
                        index = i
                    }
                })

                return index
            },
            getScoreCardSections: function () {
                let sc = {
                    what: 'ScoreCardSections'
                }

                this.$socket.makeGetRequest(sc)
                    .then((response) => {
                        if (response.type == "ScoreCardSections") {
                            console.log(response.data)
                            this.scorecard_sections = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            getScoreCardSectionFields: function () {
                let sc = {
                    what: 'ScoreCardSectionFields'
                }

                this.$socket.makeGetRequest(sc)
                    .then((response) => {
                        if (response.type == "ScoreCardSectionFields") {
                            console.log(response.data)
                            this.scorecard_fields = response.data
                        }
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            },

            createScoreCardSection: function () {
                let sc = {
                    what: 'CreateScoreCardSection',
                    data: this.new_section
                }

                this.$socket.makePostRequest(sc)
                    .then((response) => {
                        if (response.type == "CreateScoreCardSection") {
                            $('.modal').modal('hide')
                            this.new_section = initalSectionState()
                            this.$swal.fire('Success', 'Section added', 'success')
                            this.init()
                        }
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                        console.log(error)
                    })
            },

            addFieldToSection: function (e) {

                this.new_field.sectionid = e.target[0].value
                this.new_field.sectiontitle = e.target[1].value
                this.new_field.sectiontext = e.target[2].value
                let section = []
                section[0] = this.new_field
                let sc = {
                    what: 'CreateSectionField',
                    data: { "section": section }
                }

                //console.log(sc)
                this.$socket.makePostRequest(sc)
                    .then((response) => {
                        if (response.type == "CreateSectionField") {

                            e.target[0].value = ""
                            e.target[1].value = ""
                            e.target[2].value = ""

                            this.$swal.fire('Success', 'Field added', 'success')
                            this.init()
                        }
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                        console.log(error)
                    })
            },
            editScoreCardSection: function (id, index) {

                var editScoreCardSection = {
                    what: 'EditScoreCardSection',
                    id: id,
                    data: this.scorecard_sections[index]
                }
                console.log(editScoreCardSection)
                this.$socket.makeEditRequest(editScoreCardSection)
                    .then((response) => {
                        this.$swal.fire('Success', response.data.message, 'success')
                        setTimeout(window.location.reload(), 6000)
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                    })
            },
            deleteSection: function (id) {
                let c = confirm("Are you sure? Proceeding will delete the section ")
                if (c) {
                    //console.log(this.scorecard_sections[index])
                    var deletesection = {
                        what: 'DeleteScoreCardSection',
                        id: id,
                    }
                    this.$socket.makeDeleteRequest(deletesection)
                        .then((response) => {
                            this.$swal.fire('Success', response.message, 'success')
                            setTimeout(window.location.reload(), 6000)
                        })
                        .catch((error) => {
                            this.$swal.fire('Error', error.message, 'error')
                        })
                }
            },
            editScoreCardField: function (id, index) {
                var editscorecardfield = {
                    what: 'EditSectionField',
                    id: id,
                    data: this.scorecard_fields[index]
                }
                console.log(editscorecardfield)
                this.$socket.makeEditRequest(editscorecardfield)
                    .then((response) => {
                        this.$swal.fire('Success', response.data.message, 'success')
                        setTimeout(window.location.reload(), 6000)
                    })
                    .catch((error) => {
                        this.$swal.fire('Error', error.message, 'error')
                    })
            },
            deleteField: function (id) {
                let c = confirm("Are you sure? Proceeding will delete the field ")
                if (c) {
                    //console.log(this.scorecard_sections[index])
                    var deletefield = {
                        what: 'DeleteSectionField',
                        id: id,
                    }
                    this.$socket.makeDeleteRequest(deletefield)
                        .then((response) => {
                            this.$swal.fire('Success', response.message, 'success')
                            setTimeout(window.location.reload(), 6000)
                        })
                        .catch((error) => {
                            this.$swal.fire('Error', error.message, 'error')
                        })
                }
                //console.log(sectionid)
            },

            breakString: function (str) {
                // if(str !== null){
                //     let s = str.match(new RegExp('.{1,40}', 'g'))
                //     return s.join('-<br />')
                // }
                return str
            },

            formatAnswers: function () {

                //Array to hold scores and comments
                let ratescores = []
                //Get all the scores, the scores are indexed by the ID of the field they represent
                let scores = this.answers.scores

                //Get all the comments, the comments are indexed by the ID of the field they represent
                let comments = this.answers.comments

                //Count the scores and comments
                let scores_count = scores.length
                let comments_count = comments.length

                //We will expect that every score should have a comment but in an event where a score might be
                //missing a comment, or a comment might have been made without giving any scores, we want to 
                //get which one has elements and use that as our key looper
                let looper = (scores_count > comments_count) ? scores : comments

                //Which of the arrays ended up being the looper
                let looper_name = (scores_count > comments_count) ? "scores" : "comments"

                //Count items in looper
                let looper_count = looper.length


                //Start loop
                for (var i = 0; i < looper_count; i++) {

                    let fieldid = i + 1
                    let score = ""
                    let comment = ""

                    if (looper_name == "scores") {
                        //If the looper is the "scores" array, check if the index is undefined, 
                        //if it is, make score empty string
                        score = (looper[fieldid] !== undefined) ? looper[fieldid] : ""
                        console.log(score)
                        //Get the item from the "comments" array with the same index
                        comment = (comments[fieldid] !== undefined) ? comments[fieldid] : ""

                    } else if (looper_name == "comments") {

                        comment = (looper[fieldid] !== undefined) ? looper[fieldid] : ""
                        score = (scores[fieldid] !== undefined) ? scores[fieldid] : ""
                    }

                    let __obj = {
                        fieldid: fieldid,
                        score: score,
                        comments: comment,
                        appid: this.$route.params.id,
                        impression: this.answers.first_impression,
                        hiring_decision: this.answers.hiring_decision,
                        decision: this.answers.decision_reason

                    }
                    console.log(__obj)
                    if (__obj.score && __obj.comments !== "") {
                        ratescores.push(__obj)
                    }

                }

                return ratescores
            },

            submitForm: function () {
                let data = this.formatAnswers()
                console.log(data)
                let score = {
                    what: 'ScoreApplicant',
                    data: {
                        ratescores: data,
                        evaluator_id: this.$store.getters.user_data.data.id
                    }
                }

                /*let c = confirm("Submit new score? Proceeding will replace any existing scorecard for this candidate.")
                if(c){
                    this.$socket.makePostRequest(score)
                        .then((response)=>{
                            if(response.type == "ScoreApplicant"){
                                //console.log(response)
                                this.$swal.fire("Success", "Scorecard Saved", "success")
    
                                setTimeout(()=>{
                                    window.location.reload()
                                }, 2000)
                            }
                        })
                        .catch((error)=>{
                            this.$swal.fire("Error", error.data, "error")
                            console.log(error)
    
                        })
                }*/

                this.$socket.makePostRequest(score)
                    .then((response) => {
                        if (response.type == "ScoreApplicant") {
                            //console.log(response)
                            this.$swal.fire("Success", "Scorecard Saved", "success")

                            setTimeout(() => {
                                window.location.reload()
                            }, 2000)
                        }
                    })
                    .catch((error) => {
                        this.$swal.fire("Error", error.data, "error")
                        console.log(error)

                    })

            },

            getApplicantScoreCard: function (id) {

                if (this.$route.query.evaluator == undefined) {
                    let request = {
                        what: 'ApplicantScorecard',
                        params: {
                            appID: id,
                            evaluator_id: this.$store.getters.user_data.data.id
                        }
                    }

                    this.$socket.makeGetRequest(request)
                        .then((response) => {
                            if (response.type == "ApplicantScorecard") {
                                this.applicant_score = response.data
                                console.log(response.data)
                                var score = 0;
                                for (var i = 0; i < this.applicant_score.length; i++) {
                                    score = score + parseInt(this.applicant_score[i].score)
                                    this.final_first_impression = this.applicant_score[i].impression
                                    this.final_hiring_decision = this.applicant_score[i].hiring_decision
                                    this.final_decision_reason = this.applicant_score[i].decision
                                }
                                this.applicant_total = score
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                } else {
                    let request = {
                        what: 'ApplicantScorecard',
                        params: {
                            appID: id
                        }
                    }

                    this.$socket.makeGetRequest(request)
                        .then((response) => {
                            if (response.type == "ApplicantScorecard") {

                                //Get evaluations of the specific evaluator ID supplied
                                var data = response.data
                                var res_count = data.length

                                for (var i = 0; i < res_count; i++) {
                                    if (data[i].id == this.$route.query.evaluator) {
                                        this.evaluator_card = data[i]
                                        this.applicant_score = data[i].evaluations
                                    }
                                }

                                var score = 0;

                                for (var i = 0; i < this.applicant_score.length; i++) {
                                    score = score + parseInt(this.applicant_score[i].score)
                                }

                                this.applicant_total = score
                            }
                        })
                        .catch((error) => {
                            console.log(error)
                        })
                }

            }
        },
        computed: {

        }
    }
</script>